import { createSelector } from 'reselect';
import { GlobalState } from '../rootReducer';

// reducer
const DEFAULT_STATE = {
    hostname: '',
    isWhiteLabel: false,
    logo: '',
    name: '',
    sellerId: 0,
    siteName: '',
    siteUrl: '',
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.whiteLabel;

export const getHostName = createSelector(stateSelector, (state) => {
    return state ? state.hostname : '';
});

export const getWhiteLabelLogo = createSelector(stateSelector, (state) => state.logo);
export const getWhiteLabelName = createSelector(stateSelector, (state) => state.name);
export const getWhiteLabelSellerId = createSelector(stateSelector, (state) => state.sellerId);
export const getWhiteLabelSiteName = createSelector(stateSelector, (state) => state.siteName);
export const getWhiteLabelSiteUrl = createSelector(stateSelector, (state) => {
    if (Boolean(state.siteUrl) && !state.siteUrl.includes('http')) {
        return `//${state.siteUrl}`;
    }
    return state.siteUrl;
});
export const getIsWhiteLabel = createSelector(stateSelector, (state) => Boolean(state.isWhiteLabel));
